
import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.scss']
})

export class LoginLayoutComponent implements OnInit {
    constructor(protected injector: Injector, private translation : TranslateService) { }

    ngOnInit() { }

    changeLanguage(language: string) {
        if (language !== this.translation.currentLang) {
            this.translation.use(language)
        }
    }
}